<template>
<div class="header" :class="{ active: isActive, 'menu-dark': isMenuDark }" :style="headerStyle">
	<div class="logo">
		<img class="logoIcon" src='@/assets/logo.png' @click="jump(0)" />
	</div>
	<div style="flex: 1; height: 1px;" />
	
	<div class="menu">
		<div class="menuItemBox" v-for="(item, index) in menuItems" :key="index">
			<div :style="{'width': index == 0 ? '0' : '3.7rem','height': index == 0 ? '0' : '1'}"></div>
			<div class="menuItem" :class="{ selected: selected === index }" @click="jump(index)">
				<div>{{item.name}}</div>
			</div>
		</div>
	</div>

	<div class="loginButton" @click="toLogin">
		登录
	</div>
</div>
</template>

<script>
export default {
	props: {
		selected: {
			type: Number,
			required: true,
			default: 0
		},
		menuItems: {
			type: Array,
			required: true,
		},
		thresholdHeight: {
			type: Number,
			default: 20
		}
	},
	data() {
		return {
			scrollProgress: 0,
		}
	},
	computed: {
		headerStyle() {
			const progress = this.scrollProgress

			return {
				background: `rgba(255, 255, 255, ${0.6 * progress})`,
				backdropFilter: `blur(${67 * progress}px)`,
				webkitBackdropFilter: `blur(${67 * progress}px)`
			}
		},
		isActive() {
			return this.scrollProgress > 0
		},
		isMenuDark() {
			return this.scrollProgress > 1 / 3
		}
	},
	methods: {
		jump(index) {
			this.$emit("changeDisplayingContent", index);
		},
		toLogin() {
			window.open('/login.html', '_blank');
		},
		
		handleScroll() {
			// const start = this.thresholdHeight
			const start = 0
			const range = this.thresholdHeight * 0.5
			const y = window.scrollY

			const progress = (y - start) / range
			this.scrollProgress = Math.max(0, Math.min(1, progress))
		}
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll);
		window.addEventListener("resize", this.handleScroll);

		this.handleScroll();
		this.$emit('height', this.$el.getBoundingClientRect().height)
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.handleScroll);
		window.removeEventListener("resize", this.handleScroll);
	},
	created() {
	},
	watch: {
		selected(val) {
			console.log("页面变动"+val)
		},
		thresholdHeight() {
			this.handleScroll();
		}
	},
}
</script>

<style scoped>
.header {
	overflow: hidden;
	position: fixed;
	top: 0;
	width: 100%;
	min-height: 26px;
	padding-top: 10px;
	padding-bottom: 10px;
	display: flex;
	flex-direction: row;
	justify-content: center;

	background: rgba(255, 255, 255, 0);
	backdrop-filter: blur(0px);
	-webkit-backdrop-filter: blur(0px);
	transition: color 0.3s ease;
}

.logo{
	width: fit-content;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-left: 90px;
}
	.logoIcon {
		width: 105px;
		height: 26px;
		object-fit: contain;
		cursor: pointer;
	}

.menu {
	width: fit-content;
	display: flex;
	flex-direction: row;
	justify-content: center;
}
	.menuItemBox {
		width: fit-content;
		display: flex;
		flex-direction: row;
		justify-content: center;
	}
	.menuItem {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: rgba(255, 255, 255, 0.85);
		cursor: pointer;
		font-size: 1.3rem;
		transition: color 0.3s ease, opacity 0.3s ease;
	}
	.menuItem.selected {
		color: #78DFA2;
	}
	.header.menu-dark .menuItem {
		color: #333333;
	}
	.header.active .menuItem.selected {
		color: #78DFA2;
	}
	.menuItem:hover {
		opacity: 0.85;
		transition: color 0.3s ease, opacity 0.3s ease;
	}

.loginButton {
	margin-left: 1.8rem;
	margin-right: 90px;
	width: 10rem;
	height: 3.5rem;
	background-color: #78DFA2;
	font-size: 1.2rem;
	line-height: 3.5rem;
	text-align: center;
	color: #FFFFFF;
	cursor: pointer;
}
.loginButton:hover {
	opacity: 0.85;
	transition: color 0.3s ease, opacity 0.3s ease;
}
</style>